import { render, staticRenderFns } from "./manageTags.vue?vue&type=template&id=61309a82&scoped=true&"
import script from "./manageTags.vue?vue&type=script&lang=js&"
export * from "./manageTags.vue?vue&type=script&lang=js&"
import style0 from "./manageTags.vue?vue&type=style&index=0&id=61309a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61309a82",
  null
  
)

export default component.exports